module.exports = __webpack_public_path__ + "static/media/carousel-7.1bb43864.jpg";